import { TypographyH4 } from "@/components/typography/H4";
import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { ViewSubscriptionOffer } from "@/features/subscription-offer";
import { createFileRoute } from "@tanstack/react-router";
import { BookMarked, ExternalLink } from "lucide-react";

export const Route = createFileRoute(
  "/_auth/subscription-offer/$subscriptionOfferId"
)({
  component: SubscriptionOfferPage
});

function SubscriptionOfferPage() {
  const { subscriptionOfferId } = Route.useParams();

  return (
    <div className="grid grid-cols-2 gap-x-20 gap-y-16 min-h-screen place-content-center mx-16">
      <ViewSubscriptionOffer subscriptionOfferId={subscriptionOfferId} />

      <div className="rounded border dark:border-brand-gray-800 h-fit mt-24 p-6 grid grid-cols-[35px_1fr] gap-y-3 items-center">
        <BookMarked
          className="h-6 w-6 dark:text-brand-gray-600"
          strokeWidth="1.6"
        />
        <TypographyH4 className="col-start-2">Subscription offers</TypographyH4>
        <TypographySM className="col-start-2 row-start-2 dark:text-brand-gray-400">
          Subscription offers let you access apps from other organizations. Once
          accepted, members of your organization will be able to use the app.
          <br />
          <br />
          Subscriptions can be cancelled at any time by either your organization
          or the owner organization.
        </TypographySM>
        <a
          href="https://www.numerous.com/docs"
          className="col-start-2 row-start-3 place-self-end"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button variant="ghost">
            Read more
            <ExternalLink className="w-4 h-4 ml-2 inline" />
          </Button>
        </a>
      </div>
    </div>
  );
}
